import { createGlobalStyle } from 'styled-components/macro';

export const GlobalStyle = createGlobalStyle`
.invoice-search-actions-bold-item {
  font-weight: bold !important;
}

.k-animation-container,.DateRangePicker_picker, .SingleDatePicker_picker {
    z-index: 900 !important; //zindex for Date range picker v2
  }

[class*='List__ListStyleWrapper'] {
  max-height: 350px;
}
  
[class*='DetailPaneWrapper'] {
  height: calc(100vh - 87px) !important;
}

.k-animation-container {
  width: 400px !important;
}

.multiselect__control {
  [class*='multiselect__value-container'] {
    max-width:none;
  }
} 
`;

export default GlobalStyle;
